export default (value: number) => `${value}px`;
